// extracted by mini-css-extract-plugin
export default {"block":"styles-module--block--9N1bw","ctas":"styles-module--ctas--Ft6FM"};